module.exports = __webpack_public_path__ + "585cbdbd980c06855dcb692f936640a8.png";